import { PropsWithChildren, createContext, useContext, useState } from 'react'
import { CategoryPanelProps } from './CategoryPanel'

type BackgroundsTabPanel = { panel: 'default'; panelProps: {} } | { panel: 'category'; panelProps: CategoryPanelProps }

export const BackgroundsTabContext = createContext<
  BackgroundsTabPanel & {
    openPanel: (panel: BackgroundsTabPanel) => void
    closePanel: () => void
  }
>({
  panel: 'default',
  panelProps: {},
  openPanel: () => {},
  closePanel: () => {},
})

export const useBackgroundsTab = () => {
  const context = useContext(BackgroundsTabContext)

  if (!context) {
    throw new Error(`useBackgroundsTab must be within BackgroundsTabContext.Provider`)
  }

  return context
}

export const BackgroundsTabProvider = (props: PropsWithChildren) => {
  const [panel, setPanel] = useState<BackgroundsTabPanel>({ panel: 'default', panelProps: {} })

  const closePanel = () => {
    setPanel({ panel: 'default', panelProps: {} })
  }

  return (
    <BackgroundsTabContext.Provider
      value={{
        ...panel,
        openPanel: setPanel,
        closePanel,
      }}
    >
      {props.children}
    </BackgroundsTabContext.Provider>
  )
}
